(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                };

            /** @type {string} */
            var currentAttr = '';

            function applyVisibility() {
                element.removeClass('hidden');
                var val = angular.isUndefined(currentAttr) ? '' : currentAttr === null ? '' : String(currentAttr);
                var authoritiesList = val.replace(/\s+/g, '').split(',').filter(function (a) { return a.length > 0; });
                var result;

                if (authoritiesList.length === 0) {
                    setHidden();
                    return;
                }

                result = Principal.hasAnyAuthority(authoritiesList);
                if (result) {
                    setVisible();
                } else {
                    setHidden();
                }
            }

            attrs.$observe('hasAnyAuthority', function (interpolated) {
                currentAttr = interpolated === undefined ? '' : interpolated;
                applyVisibility();
            });

            scope.$watch(function () {
                return Principal.isAuthenticated();
            }, function () {
                applyVisibility();
            });
        }
    }
})();
